import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {
    cssOverrides: {
        modalContainer: css`
            width: auto;
        `,
        modalBody: css`
            width: auto;
            min-width: 400px;
            max-width: initial;
            max-height: initial !important;
        `,
        modalTitle: css`
            border-bottom: none;
            padding: 10px 10px 0;
        `,
        modalContent: css`
            text-align: center;
            span.zoomInIcon {
                display: none;
            }
        `,
    },
};
